import React, { useState } from 'react';

const BASE = 'https://sprungkraft-koeln.de';

const NAV_CSS = `
  /* ── reset ── */
  #sk-header-embed * { box-sizing: border-box; }
  #sk-header-embed ul { list-style: none; margin: 0; padding: 0; }

  /* ── outer wrapper ── */
  #sk-header-embed { position: relative; width: 100%; }

  /* ── phone bar ── */
  #sk-header-embed .header_telefon {
    background: #a6117e; color: #fff; font-size: 14px;
    text-align: right; height: 26px; line-height: 27px;
    font-weight: 200; padding-right: 60px;
  }

  /* ── logo ── */
  #sk-header-embed a.logo {
    position: absolute; top: 0; left: 80px; z-index: 9;
    padding: 15px 0 20px 0; background: #fff; display: block;
  }
  #sk-header-embed a.logo img { display: block; max-width: 200px; }

  /* ── desktop nav ── */
  #sk-header-embed nav.mod_navigation {
    position: relative; z-index: 8;
    background: rgba(0,153,153,0.69);
    width: 100%; text-align: right; height: 90px; overflow: visible !important;
  }
  #sk-header-embed nav.mod_navigation > ul { padding-right: 50px; }
  #sk-header-embed nav.mod_navigation li { display: inline-block; position: relative; }
  #sk-header-embed nav.mod_navigation li > a,
  #sk-header-embed nav.mod_navigation li > strong {
    display: block; font-weight: 300; color: #fff; padding: 5px;
    margin: 27px 11px; text-transform: uppercase; text-decoration: none;
    border-bottom: 4px solid rgba(0,0,0,0);
    transition: all .25s ease-in-out;
    font-size: 13px; font-family: "Open Sans","Lucida Grande",Verdana,sans-serif;
  }
  #sk-header-embed nav.mod_navigation li > a:hover,
  #sk-header-embed nav.mod_navigation li > strong {
    border-bottom: 4px solid #fff; text-decoration: none;
  }
  /* dropdown */
  #sk-header-embed nav.mod_navigation .level_2 {
    background: rgba(255,255,255,0.92);
    box-shadow: 0 10px 20px -10px rgba(0,0,0,0.6);
    margin: -4px 0 0 5px; padding: 0; border-radius: 4px; overflow: hidden;
    text-align: left; opacity: 0; position: absolute; z-index: 1000;
    left: -999em; transition: opacity .218s ease-in-out; min-width: 200px;
  }
  #sk-header-embed nav.mod_navigation li:hover > .level_2 { opacity: 1; left: auto; z-index: 9999; }
  #sk-header-embed nav.mod_navigation .level_2 li { display: block; float: none; margin: 0; }
  #sk-header-embed nav.mod_navigation .level_2 li > a,
  #sk-header-embed nav.mod_navigation .level_2 li > strong {
    margin: 0; color: #666; padding: 6px 40px;
    border-bottom: 4px solid transparent; white-space: nowrap;
  }
  #sk-header-embed nav.mod_navigation .level_2 li > a:hover { border-color: #a6117e; color: #333; }
  #sk-header-embed nav.mod_navigation .level_2 li.first { margin-top: 5px; }

  /* ── hamburger button (hidden on desktop) ── */
  #sk-header-embed .navicon_link {
    display: none;
    position: absolute; right: 0; top: 21px;
    padding: 13px; z-index: 999;
    background: rgba(255,255,255,0.6); border-radius: 5px 0 0 5px;
    cursor: pointer; border: none;
  }
  #sk-header-embed .navicon {
    display: block; width: 2.5em; height: 0.3125rem;
    background: #a5117e; border-radius: 2.5rem; margin-top: 0;
  }
  #sk-header-embed .navicon.two,
  #sk-header-embed .navicon.three { margin-top: 0.3125rem; }

  /* ── mobile slide-out drawer ── */
  #sk-mobile-overlay {
    display: none; position: fixed; inset: 0;
    background: rgba(0,0,0,0.5); z-index: 10000;
  }
  #sk-mobile-overlay.open { display: block; }
  #sk-mobile-drawer {
    position: fixed; top: 0; left: 0; bottom: 0; width: 80%; max-width: 320px;
    background: #f3f3f3; z-index: 10001; overflow-y: auto;
    transform: translateX(-100%); transition: transform 0.4s ease;
    font-family: "Open Sans","Lucida Grande",Verdana,sans-serif;
  }
  #sk-mobile-drawer.open { transform: translateX(0); }
  #sk-mobile-drawer .mm-header {
    background: rgba(0,153,153,0.69); color: #fff; padding: 16px 20px;
    font-size: 13px; text-transform: uppercase; font-weight: 300;
    letter-spacing: 0.05em;
  }
  #sk-mobile-drawer ul { list-style: none; margin: 0; padding: 0; }
  #sk-mobile-drawer li { border-bottom: 1px solid rgba(0,0,0,0.1); }
  #sk-mobile-drawer li > a,
  #sk-mobile-drawer li > strong,
  #sk-mobile-drawer li > button.mm-toggle {
    display: flex; justify-content: space-between; align-items: center;
    padding: 14px 20px; color: rgba(0,0,0,0.75); text-decoration: none;
    font-size: 14px; font-weight: 300; text-transform: uppercase;
    background: none; border: none; width: 100%; text-align: left; cursor: pointer;
  }
  #sk-mobile-drawer li > strong { color: rgba(0,153,153,0.9); font-weight: 600; }
  #sk-mobile-drawer li > a:hover { background: rgba(0,0,0,0.05); }
  #sk-mobile-drawer .level_2 { display: none; background: rgba(0,0,0,0.04); }
  #sk-mobile-drawer .level_2.open { display: block; }
  #sk-mobile-drawer .level_2 li > a {
    padding: 10px 20px 10px 36px; font-size: 13px; text-transform: none;
    color: #555; border-left: 3px solid transparent;
  }
  #sk-mobile-drawer .level_2 li > a:hover { border-left-color: #a6117e; }
  #sk-mobile-drawer .mm-arrow { font-size: 10px; opacity: 0.5; }

  /* ── responsive breakpoints ── */
  @media all and (max-width: 1230px) {
    #sk-header-embed nav.mod_navigation li > a,
    #sk-header-embed nav.mod_navigation li > strong { margin: 27px 5px 0 5px; font-size: 14px; }
    #sk-header-embed a.logo { width: 185px; }
  }
  @media all and (max-width: 1010px) {
    #sk-header-embed nav.mod_navigation { display: none; }
    #sk-header-embed .navicon_link { display: block; }
    #sk-header-embed .header_telefon { font-size: 0.0001px; color: transparent; height: 11px; }
    #sk-header-embed a.logo {
      position: relative; left: 0 !important; top: 0;
      max-width: 50%; background: transparent; padding: 0;
    }
    #sk-header-embed .inside {
      background: rgba(0,153,153,0.69); padding: 8px 0 8px 0; min-height: 56px;
    }
  }
`;

interface MobileItem {
    label: string;
    href: string;
    active?: boolean;
    children?: { label: string; href: string }[];
}

const ITEMS: MobileItem[] = [
    { label: 'Home', href: `${BASE}/home.html` },
    { label: 'Physio', href: `${BASE}/physiotherapie-22.html`, children: [
        { label: 'Fragen', href: `${BASE}/fragen-kopie.html` },
        { label: 'Fortbildungen', href: `${BASE}/Fortbildungen.html` },
        { label: 'Praxisbilder', href: `${BASE}/Praxisbilder.html` },
        { label: 'Jobangebote', href: `${BASE}/jobangebote-kopie.html` },
    ]},
    { label: 'Aquajogging | Aquafitness | Rückenfit', href: `${BASE}/Aquafitness-Aquajogging-R%C3%BCckenfitness-K%C3%B6ln-Frechen.html`, children: [
        { label: 'Aquafitness | Wassergymnastik', href: `${BASE}/aquafitnesskurse-k%C3%B6ln-aquatraining-aquajogging-k%C3%B6ln-wassergymnastik.html` },
        { label: 'Aquajogging | Aquafitness | Wassergymnastik', href: `${BASE}/aquajogging-aquafitnesskurse-k%C3%B6ln-aquakurse-im-Stadionbad-aquatraining-aquajogging-wassergymnastik.html` },
        { label: 'Rückenfitness', href: `${BASE}/R%C3%BCckentraining-R%C3%BCckenfitness-Pr%C3%A4ventionskurse-Physiotherapie-Frechen.html` },
        { label: 'Outdoorfitness', href: `${BASE}/gesundheitskurse-r%C3%BCckenfitness-aquakurse-physiotherapie.html` },
    ]},
    { label: 'Kurse | Anmeldung', href: 'https://anmeldung.sprungkraft-koeln.de', active: true },
    { label: 'Team', href: `${BASE}/team-und-partner.html`, children: [
        { label: 'Profil', href: `${BASE}/profil.html` },
    ]},
    { label: 'Info', href: `${BASE}/kontakt-Information-Fragen.html`, children: [
        { label: 'Kunden', href: `${BASE}/kunden.html` },
    ]},
    { label: 'Fragen', href: `${BASE}/haeufige-fragen.html` },
];

const MobileDrawer = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const [expanded, setExpanded] = useState<string | null>(null);

    const toggle = (label: string) =>
        setExpanded(expanded === label ? null : label);

    return (
        <>
            <div
                id="sk-mobile-overlay"
                className={open ? 'open' : ''}
                onClick={onClose}
            />
            <div id="sk-mobile-drawer" className={open ? 'open' : ''}>
                <div className="mm-header">Sprungkraft Köln</div>
                <ul>
                    {ITEMS.map((item) => (
                        <li key={item.label}>
                            {item.children ? (
                                <>
                                    <button
                                        className="mm-toggle"
                                        onClick={() => toggle(item.label)}
                                    >
                                        {item.label}
                                        <span className="mm-arrow">
                                            {expanded === item.label ? '▲' : '▶'}
                                        </span>
                                    </button>
                                    <ul className={`level_2${expanded === item.label ? ' open' : ''}`}>
                                        <li>
                                            <a href={item.href} target="_blank" rel="noreferrer noopener" onClick={onClose}>
                                                {item.label} (Übersicht)
                                            </a>
                                        </li>
                                        {item.children.map((c) => (
                                            <li key={c.href}>
                                                <a href={c.href} target="_blank" rel="noreferrer noopener" onClick={onClose}>
                                                    {c.label}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : item.active ? (
                                <strong>{item.label}</strong>
                            ) : (
                                <a href={item.href} target="_blank" rel="noreferrer noopener" onClick={onClose}>
                                    {item.label}
                                </a>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

// Static desktop HTML (CSS hover dropdowns, no JS needed)
const DESKTOP_HTML = `
<div class="header_telefon">Infos unter: ☎ 02234 / 9599832</div>
<a class="logo" href="${BASE}/" target="_blank" rel="noreferrer noopener">
  <img src="${BASE}/files/theme/img/logo.jpg" alt="Sprungkraft Logo" />
</a>
<nav class="mod_navigation block">
  <ul class="level_1">
    <li class="first"><a href="${BASE}/home.html" target="_blank" rel="noreferrer noopener">Home</a></li>
    <li class="submenu">
      <a href="${BASE}/physiotherapie-22.html" target="_blank" rel="noreferrer noopener">Physio</a>
      <ul class="level_2">
        <li class="first"><a href="${BASE}/fragen-kopie.html" target="_blank" rel="noreferrer noopener">Fragen</a></li>
        <li><a href="${BASE}/Fortbildungen.html" target="_blank" rel="noreferrer noopener">Fortbildungen</a></li>
        <li><a href="${BASE}/Praxisbilder.html" target="_blank" rel="noreferrer noopener">Praxisbilder</a></li>
        <li class="last"><a href="${BASE}/jobangebote-kopie.html" target="_blank" rel="noreferrer noopener">Jobangebote</a></li>
      </ul>
    </li>
    <li class="submenu">
      <a href="${BASE}/Aquafitness-Aquajogging-R%C3%BCckenfitness-K%C3%B6ln-Frechen.html" target="_blank" rel="noreferrer noopener">Aquajogging | Aquafitness | Rückenfit</a>
      <ul class="level_2">
        <li class="first"><a href="${BASE}/aquafitnesskurse-k%C3%B6ln-aquatraining-aquajogging-k%C3%B6ln-wassergymnastik.html" target="_blank" rel="noreferrer noopener">Aquafitness | Wassergymnastik</a></li>
        <li><a href="${BASE}/aquajogging-aquafitnesskurse-k%C3%B6ln-aquakurse-im-Stadionbad-aquatraining-aquajogging-wassergymnastik.html" target="_blank" rel="noreferrer noopener">Aquajogging | Aquafitness | Wassergymnastik</a></li>
        <li><a href="${BASE}/R%C3%BCckentraining-R%C3%BCckenfitness-Pr%C3%A4ventionskurse-Physiotherapie-Frechen.html" target="_blank" rel="noreferrer noopener">Rückenfitness</a></li>
        <li class="last"><a href="${BASE}/gesundheitskurse-r%C3%BCckenfitness-aquakurse-physiotherapie.html" target="_blank" rel="noreferrer noopener">Outdoorfitness</a></li>
      </ul>
    </li>
    <li><strong>Kurse | Anmeldung</strong></li>
    <li class="submenu">
      <a href="${BASE}/team-und-partner.html" target="_blank" rel="noreferrer noopener">Team</a>
      <ul class="level_2">
        <li class="first last"><a href="${BASE}/profil.html" target="_blank" rel="noreferrer noopener">Profil</a></li>
      </ul>
    </li>
    <li class="submenu">
      <a href="${BASE}/kontakt-Information-Fragen.html" target="_blank" rel="noreferrer noopener">Info</a>
      <ul class="level_2">
        <li class="first last"><a href="${BASE}/kunden.html" target="_blank" rel="noreferrer noopener">Kunden</a></li>
      </ul>
    </li>
    <li class="last"><a href="${BASE}/haeufige-fragen.html" target="_blank" rel="noreferrer noopener">Fragen</a></li>
  </ul>
</nav>
`;

const SprungkraftNavbar = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: NAV_CSS }} />
            <div id="sk-header-embed">
                <div
                    className="inside"
                    dangerouslySetInnerHTML={{ __html: DESKTOP_HTML }}
                />
                {/* hamburger — visible only on mobile via CSS */}
                <button
                    className="navicon_link"
                    onClick={() => setDrawerOpen(true)}
                    aria-label="Menü öffnen"
                >
                    <div className="navicon one" />
                    <div className="navicon two" />
                    <div className="navicon three" />
                </button>
            </div>
            <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        </>
    );
};

export default SprungkraftNavbar;
